<template>
  <div class="page-content">
    <div class="shop-sale">
      <h1 class="page-title">{{ $locale("sideMenu.reports.shopSale") }}</h1>

      <!-- Search Area -->
      <el-row class="search-area egl-elm">
        <el-col :span="16">
          <el-row>
            <el-col :span="20">
              <DatePickerGroup
                v-bind:start="filter.startDate"
                v-bind:end="filter.endDate"
                @setFatherDate="getDate"
              ></DatePickerGroup>
            </el-col>
            <el-col :span="4">
              <el-button
                class="egl-btn-yellow right-align-btn"
                @click="search_fn"
                >{{ $locale("global.confirm") }}</el-button
              >
            </el-col>
            <!-- <el-col :span="8" class="search-item">
              <el-row :gutter="10" class="cur-day">
                <el-col :span="4">
                  <el-button
                    class="egl-btn-yellow"
                    @click="getCurDay(-1, 'startDate')"
                    >&lt;</el-button
                  >
                </el-col>
                <el-col :span="16">
                  <el-date-picker
                    type="date"
                    v-model="filter.startDate"
                    :clearable="false"
                    @change="getCurDay('', 'startDate')"
                    value-format="timestamp"
                    :picker-options="startTimePickerOptions"
                  >
                  </el-date-picker>
                </el-col>
                <el-col :span="4">
                  <el-button
                    class="egl-btn-yellow"
                    @click="getCurDay(1, 'startDate')"
                    >&gt;</el-button
                  >
                </el-col>
              </el-row>
            </el-col> -->
            <!-- <el-col :span="1" class="time-connect">~</el-col> -->
            <!-- <el-col :span="8" class="search-item">
              <el-row :gutter="10" class="cur-day">
                <el-col :span="4">
                  <el-button
                    class="egl-btn-yellow"
                    @click="getCurDay(-1, 'endDate')"
                    >&lt;</el-button
                  >
                </el-col>
                <el-col :span="16">
                  <el-date-picker
                    type="date"
                    v-model="filter.endDate"
                    :clearable="false"
                    @change="getCurDay('', 'endDate')"
                    value-format="timestamp"
                    :picker-options="endTimePickerOptions"
                  >
                  </el-date-picker>
                </el-col>
                <el-col :span="4">
                  <el-button
                    class="egl-btn-yellow"
                    @click="getCurDay(1, 'endDate')"
                    >&gt;</el-button
                  >
                </el-col>
              </el-row>
            </el-col> -->
          </el-row>
        </el-col>
        <el-col :span="8" class="ta-r">
          <el-row>
            <el-col :span="24">
              <el-button class="egl-btn-yellow right-align-btn" @click="exportCSV">{{
                $locale("global.exportToCSV")
              }}</el-button>
              <el-button style="min-width: 200px;" class="egl-btn-yellow" v-print="printObj">{{ $locale("global.printBtn") }}</el-button>
              <!-- <el-button class="egl-btn-yellow right-align-btn">{{
                $locale("global.print")
              }}</el-button> -->
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <!-- <el-select
            v-model="filter.clientIds"
            :placeholder="$locale('form.plsSelect')"
            multiple
            :filterable="true"
          >
            <el-option v-for="item in clientList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select> -->
          <remote-select
            type="client"
            v-model="filter.clientIds"
            :formValue.sync="filter.clientIds"
          ></remote-select>
        </el-col>
      </el-row>
      <div id="print">
        <div class="table-module sale-table">
        <h3>{{$locale("report.shopSale.shopSale")}}</h3>
        <el-row class="module-sms">
          <el-col :span="6">{{ $locale('trans.report.period') }}：{{ period }}</el-col>
          <el-col :span="7">劇場名：{{ cinemaName }}</el-col>
          <el-col :span="6">会社名：{{ brandName }}</el-col>
          <el-col :span="5">{{ $locale('trans.report.generatedate') }}：{{ searchTime }}</el-col>
        </el-row>

        <h4>{{$locale("report.shopSale.proxy")}}</h4>
        <div class="table-box">
          <el-table :data="table1.tableData" class="egl-table" :span-method="merge4arrayMethod_consignment" border :cell-class-name="alignRight">
            <el-table-column
              :label="$locale('accountPayable.client')"
              prop="clientName"
              min-width="160"
            ></el-table-column>
            <el-table-column
              :label="$locale('trans.koisk.salesgroup')"
              prop="salesGroupName"
              :width="200"
            ></el-table-column>
            <el-table-column
              :label="$locale('global.department')"
              prop="groupName"
              :width="200"
            ></el-table-column>
            <el-table-column
              :label="$locale('inventoryLog.name')"
              prop="name"
              :width="200"
            ></el-table-column>
            <el-table-column
              :label="$locale('report.shopSale.cost')"
              prop="cost"
              :formatter="priceFormat"
              :width="200"
            ></el-table-column>
            <el-table-column
              :label="$locale('report.shopSale.taxRate')"
              prop="taxRate"
              :width="200"
            ></el-table-column>
            <el-table-column
              :label="$locale('report.shopSale.unitPrice')"
              prop="unitPrice"
              :formatter="priceFormat"
              :width="200"
            ></el-table-column>
            <el-table-column
              :label="$locale('global.quantity')"
              prop="qty"
              :width="200"
            ></el-table-column>
            <el-table-column
              :label="$locale('report.shopSale.keshang')"
              prop="amount"
              :formatter="priceFormat"
              :width="200"
            ></el-table-column>
            <el-table-column
              :label="$locale('report.shopSale.culi')"
              prop="culi"
              :formatter="priceFormat"
              :width="200"
            ></el-table-column>
          </el-table>
        </div>

        <h4>{{$locale("report.shopSale.shopSale.buy")}}</h4>
        <div class="table-box">
          <el-table :data="table2.tableData" class="egl-table" :span-method="merge4arrayMethod_salesItem" border :cell-class-name="alignRight">
            <el-table-column
              :label="$locale('accountPayable.client')"
              prop="clientName"
              min-width="160"
            ></el-table-column>
            <el-table-column
              :label="$locale('trans.koisk.salesgroup')"
              prop="salesGroupName"
              :width="200"
            ></el-table-column>
            <el-table-column
              :label="$locale('global.department')"
              prop="groupName"
              :width="200"
            ></el-table-column>
            <el-table-column
              :label="$locale('inventoryLog.name')"
              prop="name"
              :width="200"
            ></el-table-column>
            <el-table-column
              :label="$locale('report.shopSale.cost')"
              prop="cost"
              :width="200"
              :formatter="priceFormat"
            ></el-table-column>
            <el-table-column
              :label="$locale('report.shopSale.taxRate')"
              prop="taxRate"
              :width="200"
            ></el-table-column>
            <el-table-column
              :label="$locale('report.shopSale.unitPrice')"
              prop="unitPrice"
              :width="200"
              :formatter="priceFormat"
            ></el-table-column>
            <el-table-column
              :label="$locale('global.quantity')"
              prop="qty"
              :width="200"
            ></el-table-column>
            <el-table-column
              :label="$locale('report.shopSale.keshang')"
              prop="amount"
              :width="200"
              :formatter="priceFormat"
            ></el-table-column>
            <el-table-column
              :label="$locale('report.shopSale.culi')"
              prop="culi"
              :width="200"
              :formatter="priceFormat"
            ></el-table-column>
          </el-table>
        </div>
      </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import { getShopSalesReport } from "@/helpers/service/api/report";
import DatePickerGroup from "@/components/DatePickerGroup";
import { exportCSV_fn } from "@/assets/js/shopSale_exportCSV";
import { taxRatesMap, toThousands } from "@/utils/common";
import "@/assets/style/shopSale.less";
import { getClientListService } from "@/helpers/service/api/common";
import RemoteSelect from "@/components/common/RemoteSelect";

export default {
  name: "ShopSale",
  data() {
    return {
      printObj: {
        popTitle: this.$locale("sideMenu.reports.shopSale"),
        id: "print"
      },
      onSearch: {
        startDate: "",
        endDate: ""
      },
      filter: {
        startDate: this.$moment().startOf("day").valueOf(),
        endDate: this.$moment().startOf("day").valueOf(),
        clientIds: [],
      },
      endTimePickerOptions: {
        disabledDate: this.endTimeDisableDate
      },
      startTimePickerOptions: {
        disabledDate: this.startTimeDisableDate
      },
      cinemaName: "",
      brandName: "",
      searchTime: "",
      period: "",
      apiData: [],
      table1: {
        tableData: []
      },
      table2: {
        tableData: []
      },
      clientList: [],
    };
  },
  methods: {
    getDate(obj) {
      const { startDate, endDate } = obj || {};
      if (startDate) {
        this.filter.startDate = startDate;
      }
      if (endDate) {
        this.filter.endDate = endDate;
      }
    },
    endTimeDisableDate(time) {
      return (
        time.getTime() > Date.now() ||
        time.getTime() < this.$moment(this.filter.startDate).valueOf()
      );
    },
    startTimeDisableDate(time) {
      return time.getTime() > this.$moment(this.filter.endDate).valueOf();
    },
    getCurDay(num = "", keyName) {
      const today = this.$moment().valueOf();
      let newFilter = { ...this.filter };
      let day = "";

      if (num == "") {
        day = this.$moment(newFilter[keyName]).valueOf();
      } else {
        day = this.$moment(newFilter[keyName])
          .subtract(-num, "days")
          .valueOf();
      }

      newFilter[keyName] = day;

      newFilter.endDate =
        newFilter.endDate < newFilter.startDate
          ? newFilter.startDate
          : newFilter.endDate;
      newFilter.endDate = newFilter.endDate > today ? today : newFilter.endDate;
      newFilter.startDate =
        newFilter.startDate > newFilter.endDate
          ? newFilter.endDate
          : newFilter.startDate;

      this.filter = { ...newFilter };
    },
    search_fn() {
      const that = this;
      let cinemaId = window.localStorage.getItem("cinemaId") || "";
      let cinemaObj = window.localStorage.getItem("cinemaObj") || "";
      let cinemaName = "";

      if (cinemaId != "") {
        cinemaObj = JSON.parse(cinemaObj);
        for (let i = 0; i < cinemaObj.length; i++) {
          if (cinemaObj[i].id == cinemaId) {
            cinemaName = cinemaObj[i].name;
            break;
          }
        }

        this.cinemaName = cinemaName;
      }

      if (cinemaId == "") {
        this.$emit("callCinema", "search_fn");

        return;
      }

      let obj = {
        ...that.onSearch,
        ...that.filter
      };

      that.onSearch = { ...obj };

      getShopSalesReport({
        cinemaId,
        startDate: that.$moment(obj.startDate).format("YYYY-MM-DD"),
        endDate: that.$moment(obj.endDate).format("YYYY-MM-DD"),
        ...this.filter.clientIds.length > 0 ? { clientIds: this.filter.clientIds } : {}
      })
        .then(res => {
          // const checkboxName = ["groupName", "name", "taxRate"];

          // let initData = that.formatTableData(
          //   res.data.shopSalesRecords,
          //   checkboxName
          // );
          let initData = this.formatData(res.data);
          that.searchTime = that.$moment().format("YYYY-MM-DD HH:mm:ss");
          that.brandName = res.data.brandName;
          that.period =
            that.$moment(obj.startDate).format("YYYY-MM-DD") +
            " ~ " +
            that.$moment(obj.endDate).format("YYYY-MM-DD");
          that.apiData = res.data.shopSalesRecords;
          // do some thing
          this.table1 = {
            tableData: initData.consignment
          };
          this.table2 = {
            tableData: initData.salesItem
          };
          // that.table1 = {
          //   tableData: initData.tb1.tableData
          // };
          // that.table2 = {
          //   tableData: initData.tb2.tableData
          // };
        })
        .catch(err => {});
    },
    formatTableData(data, keyName_arr) {
      // CONSIGNMENT, //郵寄（委託商品）
      // SALES_ITEM //銷售（買取商品）
      let obj = {
        tb1: {
          tableData: [],
          checkbox: {},
          nameIndex: []
        },
        tb2: {
          tableData: [],
          checkbox: {},
          nameIndex: []
        }
      };
      let tb_name = "";

      keyName_arr.map(text => {
        obj.tb1.checkbox[text] = [];
        obj.tb2.checkbox[text] = [];
      });

      data.map(item => {
        let tr = {};
        let nameIndex = 0;

        if (item.productType == "CONSIGNMENT") {
          tb_name = "tb1";
        } else {
          tb_name = "tb2";
        }

        nameIndex = obj[tb_name].nameIndex.indexOf(item.name);

        if (nameIndex >= 0) {
          obj[tb_name].tableData[nameIndex].type = item.salesGroupName
          obj[tb_name].tableData[nameIndex].num =
            item.qty + 1;
          obj[tb_name].tableData[nameIndex].keshang =
            obj[tb_name].tableData[nameIndex].num *
            obj[tb_name].tableData[nameIndex].unitPrice;
          obj[tb_name].tableData[nameIndex].culi = (item.unitPrice - item.cost) * item.qty
          obj[tb_name].tableData[nameIndex].taxRate = taxRatesMap[item.taxRate]
        } else {
          tr.type = item.salesGroupName;
          tr.groupName = item.groupName;
          tr.name = item.name;
          tr.cost = item.cost;
          tr.taxRate = taxRatesMap[item.taxRate];
          tr.unitPrice = item.unitPrice;
          tr.num = item.qty;
          tr.keshang = tr.num * tr.unitPrice;
          tr.culi = (item.unitPrice - item.cost) * item.qty;

          obj[tb_name].tableData.push({ ...tr });
          obj[tb_name].nameIndex.push(item.name);
        }
      });

      return obj;
    },
    exportCSV() {
      exportCSV_fn({
        cinemaId: window.localStorage.getItem("cinemaId"),
        startDate: this.$moment(this.filter.startDate).format("YYYY-MM-DD"),
        endDate: this.$moment(this.filter.endDate).format("YYYY-MM-DD")
      });
    },
    formatData(data) {
      let _arrConsignment = [];
      let _arrSalesItem = [];
      // CONSIGNMENT
      data.consignmentRecords.forEach(client => {
        client.salesGroupRecords.forEach(salesGroup => {
          salesGroup.groupRecords.forEach(group => {
            group.shopRecords.forEach(shop => {
              _arrConsignment.push({
                clientName: client.clientName,
                salesGroupName: salesGroup.salesGroupName,
                groupName: group.groupName,
                name: shop.name,
                cost: shop.cost,
                taxRate: taxRatesMap[shop.taxRate],
                unitPrice: shop.unitPrice,
                qty: shop.qty,
                amount: shop.amount,
                culi: (shop.unitPrice - shop.cost) * shop.qty
              });
            });
             _arrConsignment.push({
              type: "group",
              clientName: client.clientName,
              salesGroupName: salesGroup.salesGroupName,
              groupName: this.$locale("report.group.subTotal"),
              name: "",
              cost: "",
              taxRate: "",
              unitPrice:"",
              qty:  group.shopRecords.reduce((total, item) => total + item.qty, 0),
              amount: group.shopRecords.reduce((total, item) => total + item.amount, 0),
              culi: group.shopRecords.reduce((total, item) => total + (item.unitPrice - item.cost) * item.qty, 0),
            });
          });
          _arrConsignment.push({
            type: "salesGroup",
            clientName: client.clientName,
            salesGroupName: this.$locale("report.salesGroup.subTotal"),
            groupName: "",
            name: "",
            cost: "",
            taxRate: "",
            unitPrice:"",
            qty:  _arrConsignment.filter(item => item.type === "group" && item.clientName === client.clientName).reduce((total, item) => total + item.qty, 0),
            amount: _arrConsignment.filter(item => item.type === "group" && item.clientName === client.clientName).reduce((total, item) => total + item.amount, 0),
            culi:  _arrConsignment.filter(item => item.type === "group" && item.clientName === client.clientName).reduce((total, item) => total + item.culi, 0),
          });
        });
        _arrConsignment.push({
          type: "client",
          clientName: this.$locale("report.client.subTotal"),
          salesGroupName: "",
          groupName: "",
          name: "",
          cost: "",
          taxRate: "",
          unitPrice:"",
          qty:  _arrConsignment.filter(item => item.type === "salesGroup" && item.clientName === client.clientName).reduce((total, item) => total + item.qty, 0),
          amount: _arrConsignment.filter(item => item.type === "salesGroup" && item.clientName === client.clientName).reduce((total, item) => total + item.amount, 0),
          culi:  _arrConsignment.filter(item => item.type === "salesGroup" && item.clientName === client.clientName).reduce((total, item) => total + item.culi, 0),
        });
      });
      if (_arrConsignment.length > 0) {
        _arrConsignment.push({
          type: "subTotal",
          clientName: this.$locale("report.shopSale.subTotal"),
          salesGroupName: "",
          groupName: "",
          name: "",
          cost: "",
          taxRate: "",
          unitPrice: "",
          qty: _arrConsignment.filter(item => item.type === "client").reduce((total, item) => total + item.qty, 0),
          amount: _arrConsignment.filter(item => item.type === "client").reduce((total, item) => total + item.amount, 0),
          culi: _arrConsignment.filter(item => item.type === "client").reduce((total, item) => total + item.culi, 0),
        });
      }
      // SALESITEM
      data.salesItemRecords.forEach(client => {
        client.salesGroupRecords.forEach(salesGroup => {
          salesGroup.groupRecords.forEach(group => {
            group.shopRecords.forEach(shop => {
              _arrSalesItem.push({
                clientName: client.clientName,
                salesGroupName: salesGroup.salesGroupName,
                groupName: group.groupName,
                name: shop.name,
                cost: shop.cost,
                taxRate: taxRatesMap[shop.taxRate],
                unitPrice: shop.unitPrice,
                qty: shop.qty,
                amount: shop.amount,
                culi: (shop.unitPrice - shop.cost) * shop.qty
              });
            });
             _arrSalesItem.push({
              type: "group",
              clientName: client.clientName,
              salesGroupName: salesGroup.salesGroupName,
              groupName: this.$locale("report.group.subTotal"),
              name: "",
              cost: "",
              taxRate: "",
              unitPrice:"",
              qty:  group.shopRecords.reduce((total, item) => total + item.qty, 0),
              amount: group.shopRecords.reduce((total, item) => total + item.amount, 0),
              culi: group.shopRecords.reduce((total, item) => total + (item.unitPrice - item.cost) * item.qty, 0),
            });
          });
          _arrSalesItem.push({
            type: "salesGroup",
            clientName: client.clientName,
            salesGroupName: this.$locale("report.salesGroup.subTotal"),
            groupName: "",
            name: "",
            cost: "",
            taxRate: "",
            unitPrice:"",
            qty:  _arrSalesItem.filter(item => item.type === "group" && item.clientName === client.clientName && item.salesGroupName === salesGroup.salesGroupName).reduce((total, item) => total + item.qty, 0),
            amount:  _arrSalesItem.filter(item => item.type === "group" && item.clientName === client.clientName && item.salesGroupName === salesGroup.salesGroupName).reduce((total, item) => total + item.amount, 0),
            culi:  _arrSalesItem.filter(item => item.type === "group" && item.clientName === client.clientName && item.salesGroupName === salesGroup.salesGroupName).reduce((total, item) => total + item.culi, 0),
          });
        });
        _arrSalesItem.push({
          type: "client",
          clientName: this.$locale("report.client.subTotal"),
          salesGroupName: "",
          groupName: "",
          name: "",
          cost: "",
          taxRate: "",
          unitPrice:"",
          qty:  _arrSalesItem.filter(item => item.type === "salesGroup" && item.clientName === client.clientName).reduce((total, item) => total + item.qty, 0),
          amount: _arrSalesItem.filter(item => item.type === "salesGroup" && item.clientName === client.clientName).reduce((total, item) => total + item.amount, 0),
          culi:  _arrSalesItem.filter(item => item.type === "salesGroup" && item.clientName === client.clientName).reduce((total, item) => total + item.culi, 0),
        });
      });
      if (_arrSalesItem.length > 0) {
        _arrSalesItem.push({
          type: "subTotal",
          clientName: this.$locale("report.shopSale.subTotal"),
          salesGroupName: "",
          groupName: "",
          name: "",
          cost: "",
          taxRate: "",
          unitPrice: "",
          qty:  _arrSalesItem.filter(item => item.type === "client").reduce((total, item) => total + item.qty, 0),
          amount: _arrSalesItem.filter(item => item.type === "client").reduce((total, item) => total + item.amount, 0),
          culi: _arrSalesItem.filter(item => item.type === "client").reduce((total, item) => total + item.culi, 0),
        });
      }
      if (_arrSalesItem.length > 0 || _arrConsignment.length > 0) {
        _arrSalesItem.push({
          type: "allTotal",
          clientName: this.$locale("report.shopSale.allTotal"),
          salesGroupName: "",
          groupName: "",
          name: "",
          cost: "",
          taxRate: "",
          unitPrice: "",
          qty: _arrConsignment.filter(item => item.type === "subTotal").reduce((total, item) => total + item.qty, 0) +  _arrSalesItem.filter(item => item.type === "subTotal").reduce((total, item) => total + item.qty, 0),
          amount: _arrConsignment.filter(item => item.type === "subTotal").reduce((total, item) => total + item.amount, 0) +  _arrSalesItem.filter(item => item.type === "subTotal").reduce((total, item) => total + item.amount, 0),
          culi: _arrConsignment.filter(item => item.type === "subTotal").reduce((total, item) => total + item.culi, 0) +  _arrSalesItem.filter(item => item.type === "subTotal").reduce((total, item) => total + item.culi, 0),
        });
      }
      return {
        consignment: _arrConsignment,
        salesItem: _arrSalesItem
      };
    },
    getCount(model, key) {
      let spanArr = [];
      let pos = 0;
      for(let i = 0; i < model.length; i++) {
        if (i === 0) {
          spanArr.push(1);
          pos = 0;
        } else if (model[i][key] === model[i - 1][key] && model[i].clientName === model[i - 1].clientName) {
          spanArr[pos] += 1;
          spanArr.push(0);
        } else {
          spanArr.push(1);
          pos = i;
        }
      }
      return spanArr;
    },
    mergeComon(key, rowIndex, data) {
      const _row = this.getCount(data, key)[rowIndex];
      const _col = _row > 0 ? 1: 0;
      return {
        rowspan: _row,
        colspan: _col
      };
    },
    merge4arrayMethod_consignment({ row, column, rowIndex, columnIndex }) {
      if (row.type === "subTotal" || row.type === "allTotal" || row.type === "client") {
        if (columnIndex === 0) {
          return [1, 7];
        } else if (columnIndex > 0 && columnIndex < 7) {
          return [0, 0];
        }
      } 
      else if(row.type === "group") {
        if (columnIndex === 2) {
          return [1, 5];
        } else if (columnIndex > 2 && columnIndex < 7) {
          return [0, 0];
        }
      } 
      else if(row.type === "salesGroup") {
         if (columnIndex === 1) {
          return [1, 6];
        } else if (columnIndex > 1 && columnIndex < 7) {
          return [0, 0];
        }
      }
      switch(columnIndex) {
      case 0:
        return this.mergeComon("clientName", rowIndex, this.table1.tableData);
      case 1:
        return this.mergeComon("salesGroupName", rowIndex, this.table1.tableData);
      case 2:
        return this.mergeComon("groupName", rowIndex, this.table1.tableData);
      default:
        break;
      }
    },
    merge4arrayMethod_salesItem({ row, column, rowIndex, columnIndex }) {
      if (row.type === "subTotal" || row.type === "allTotal" || row.type === "client") {
        if (columnIndex === 0) {
          return [1, 7];
        } else if (columnIndex > 0 && columnIndex < 7) {
          return [0, 0];
        }
      }
      else if(row.type === "group") {
        if (columnIndex === 2) {
          return [1, 5];
        } else if (columnIndex > 2 && columnIndex < 7) {
          return [0, 0];
        }
      } 
      else if(row.type === "salesGroup") {
        if (columnIndex === 1) {
          return [1, 6];
        } else if (columnIndex > 1 && columnIndex < 7) {
          return [0, 0];
        }
      }
      switch(columnIndex) {
      case 0:
        return this.mergeComon("clientName", rowIndex, this.table2.tableData);
      case 1:
        return this.mergeComon("salesGroupName", rowIndex, this.table2.tableData);
      case 2:
        return this.mergeComon("groupName", rowIndex, this.table2.tableData);
      default:
        break;
      }
    },
    priceFormat(row, column, cellValue) {
      switch(column.property) {
      case "cost" :
        return "¥" + toThousands(cellValue);
      case "unitPrice" :
        return "¥" + toThousands(cellValue);
      case "amount" :
        return "¥" + toThousands(cellValue);
      case "culi" :
        return cellValue === "-" ? cellValue : "¥" + toThousands(cellValue);
      default:
        return cellValue;
      }
    },
    alignRight({row, column, rowIndex, columnIndex}) {
      if(row.type === "subTotal" || row.type === "allTotal" || row.type === "group" || row.type === "salesGroup" || row.type === "client") {
        if (columnIndex < 3) {
          return "right-bold";
        }
        return "bold";
      }
    }
  },
  // created() {
  //   getClientListService({
  //     page: 0,
  //     pageSize: 9999,
  //     field: ["id", "name", "clientCode", "groupName", "aliasName"]
  //   }).then(res => {
  //     this.clientList = [{ id: "NONE", name: "なし" } , ...res.data.data];
  //   });
  // },
  mounted() {
    // const today = this.$moment().valueOf();

    // this.filter = {
    //   startDate: today,
    //   endDate: today
    // };
    this.search_fn();
  },
  components: {
    DatePickerGroup,
    RemoteSelect
  }
};
</script>
<style lang="less" scoped>
  .table-module ::v-deep {
    .bold {
     font-weight: bold;
    }
    .right-bold {
      text-align: right;
      font-weight: bold;
    }
  }

</style>
